import { site } from "../content";
import { Icon } from "./Icon";
import { Reveal, SectionHeading } from "./Reveal";

export default function Audience() {
  return (
    <section id="para-quem" data-testid="audience-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="12"
          eyebrow="Para quem é"
          title="Feito para quem leva a experiência do cliente a sério."
          align="center"
          testId="audience-heading"
        />
        <Reveal delay={0.15}>
          <ul className="mx-auto mt-14 flex max-w-4xl flex-wrap justify-center gap-4" data-testid="audience-list">
            {site.audience.map((item) => (
              <li
                key={item.label}
                className="flex items-center gap-3 rounded-full border border-white/12 bg-graphite/60 px-6 py-3.5 backdrop-blur-md transition-[border-color] duration-300 hover:border-gold/40"
              >
                <Icon name={item.icon} className="h-4 w-4 text-gold" />
                <span className="text-sm font-semibold text-bone/80">{item.label}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
